import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import { useModal } from '../../../hooks/useModal';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import { safeHTML } from '../../../utils/safeHTML';
import PropTypes from 'prop-types';
import { useTranslation } from '../../../translations';

const PrizeNewSeasonModal = React.forwardRef(function (props, ref) {
  const { image, title, text, button, closeCallback, gachaCount } = props;
  const { closeModal, id } = useModal();
  const { t } = useTranslation();

  const handleClose = () => {
    closeCallback?.();
    closeModal(id);
  };

  return (
    <CustomModal>
      <div className={'prize-new-season-modal'} ref={ref}>
        <div className={`prize-new-season-modal__image-box`}>
          <img src={image} alt={''} />
        </div>
        <p className={`prize-new-season-modal__title`}>{safeHTML(t(title))}</p>
        <p className={`prize-new-season-modal__text`}>{safeHTML(t(text, { quantity: gachaCount }))}</p>
        <CustomButton {...button} onClick={handleClose} />
      </div>
    </CustomModal>
  );
});
export default PrizeNewSeasonModal;
PrizeNewSeasonModal.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  button: PropTypes.object.isRequired,
  closeCallback: PropTypes.func,
};
